namespace $.$$ {

	export class $shm_service_dashboard extends $.$shm_service_dashboard {

		edit_color() {
			return this.mode() === 'edit' ? 'var(--mol_theme_current)' : ''
		}

		view_color() {
			return this.mode() === 'view' ? 'var(--mol_theme_current)' : ''
		}

	}

}
